
import { getAppInsights } from "./telemetry";

export async function clientLogger(message) {

    const time = new Date();

    const entry = {
        time: time.toLocaleString("no-NO"),
        message: message || "",
    }

    const ai = getAppInsights();

    if (ai) {
        ai.trackTrace(
            { message: "clientLogger", severityLevel: 1 },
            entry,
        );
    }
}

export function sensitiveEndpointLogger(endpoint, response, status) {
    void clientLogger({
        endpoint: endpoint,
        response: response,
        status: status,
    });
}

export function endpointLogger(endpoint, request, response, status) {
    void clientLogger({
        endpoint: endpoint,
        response: response,
        status: status,
        request: request,
    });
}
